import React, {Component} from 'react';
import AdminSession from './Session';
import * as firebase from 'firebase';

/**
 * this component is the simulationContainer for admins
 * which holds all sessions
 * reads from playable sessions
 */
class AdminSessionContainer extends Component {
    constructor(props) {
        console.log("AdminSessionContainer constructor ", props);
        super(props);
        this.sessIds = {};
        this.state = {
            sessions: []
        };
    }

    deletesession(sessId){
      console.log(`DELETING ${sessId}`);
      delete this.sessIds[sessId];
      this.mergeSessionArray([]);
    }

    mergeSessionArray(newSessions){
      var that = this;
      let nowtime = new Date().getTime();
      newSessions.map(asession=>{
        this.sessIds[asession.SessionId] = asession;
      });
      let tempSessions = [];
      Object.keys(this.sessIds).map(akey=>{
        tempSessions.push(that.sessIds[akey]);
      });
      console.log("sort this:");
      console.log(tempSessions);

      tempSessions = tempSessions.filter(sessobj=>{
        return (sessobj.hasOwnProperty("Timestamp") && (parseInt(sessobj.Timestamp) > nowtime - 24*3600000));
      });
      tempSessions.sort((x,y)=>{
        if (x.SessionId > y.SessionId){
          return -1;
        }
        if (x.SessionId < y.SessionId){
          return 1;
        }
        return 0;
      });
      this.setState({sessions: tempSessions});
    }

    /**
     * on mount, go to Playable Sessions, loop
     * through and grab sessionid and title.
     * then set that data to sessions state
     */
    componentDidMount() {
        console.log("AdminSessionContainer componentDidMount", this.props);

        let sessionid, title, creator, solo, auctionMode, dealerMode, timestamp;
        let self = this;
        this.dbRefs = [];
        this.props.dbs.map(dbparent=>{
          this.dbRefs.push(dbparent.database().ref().child(this.props.institution));
        });
        this.dbRefs.map((dbRef,i)=>{
          dbRef.child("PlayableSessions").on('value', snap => {
            let rawData = snap.val();
            let sesses = [];
            for (var key in rawData) {
              sessionid = key;
              if (rawData[key]) {
                  title = rawData[key].Title;
                  creator = rawData[key].Creator;
                  solo = rawData[key].Solo;
                  timestamp = rawData[key].hasOwnProperty("Timestamp") ? rawData[key].Timestamp : 0;
                  auctionMode = rawData[key].AuctionMode;
                  dealerMode = rawData[key].DealerMode || 0;
                  sesses.push({
                      "SessionId": sessionid,
                      "Title": title,
                      "Creator": creator,
                      "Solo": solo,
                      "DB" : dbRef,
                      "DBI" : i,
                      "AuctionMode" : auctionMode,
                      "DealerMode" : dealerMode,
                      "Timestamp": timestamp
                  });
              }
            }
            this.mergeSessionArray(sesses);
          })
        });

    }


    /**
     *
     */
    componentWillUnmount() {
        console.log("AdminSessionContainer componentWillUnmount");
        this.dbRefs.map((dbRef,i)=>{
          dbRef.child("PlayableSessions").off()
        });
    }

    /**
     *
     * @returns {*}
     */
    render() {
        console.log("AdminSessionContainer render");
        return (
            <div className='session-list'>
                <table>
                    <tbody>
                    {this.state.sessions.map(function (sess, index) {
                      console.log(sess);
                        return (
                            <AdminSession key={sess.SessionId} user={this.props.user}
                                          sessionid={sess.SessionId}
                                          institution={this.props.institution} title={sess.Title}
                                          auctionMode={sess.AuctionMode}
                                          dealerMode={sess.DealerMode}
                                          db={sess.DB}
                                          dbi={sess.DBI}
                                          deleteme={this.deletesession.bind(this)}
                                          creator={sess.Creator} solo={sess.Solo}/>
                        );
                    }.bind(this))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default AdminSessionContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/SessionList.js